import React from "react"
import { graphql } from "gatsby"
import { mapDynamicComponent } from "./page"
import Layout from "../components/UI/Layout"

const Page = ({ data }) => {
  const { name, catchphrase, sections, path, locale } = data.product
  const type = "BTB"

  return (
    <>
      <Layout
        path={path}
        title={name}
        description={catchphrase}
        locale={locale}
        type={type}
        product={data.product}
      >
        {sections.map((section, index) =>
          mapDynamicComponent(section, index, locale, type)
        )}
      </Layout>
    </>
  )
}

export const query = graphql`
  query ProductQuery($id: String) {
    product: strapiProduct(id: { eq: $id }) {
      name
      catchphrase
      path
      locale
      parentPage {
        title
        name
        path
      }
      sections {
        ... on STRAPI__COMPONENT_PAGE_FEATURES {
          __typename
          id
          title {
            content
            secondary
            level
          }
          features {
            label
            name
            featureDescription {
              data {
                featureDescription
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_UI_BUTTON {
          __typename
          id
          label
          url
          variant
          align
        }
        ... on STRAPI__COMPONENT_UI_IMAGE_GALLERY {
          __typename
          id
          image {
            alternativeText
            url
            mime
            localFile {
              thumbnail: childImageSharp {
                gatsbyImageData(
                  width: 350
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  transformOptions: { cropFocus: CENTER, fit: COVER }
                )
              }
              full: childImageSharp {
                gatsbyImageData(
                  width: 1000
                  placeholder: NONE
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_UI_PAGE_GALLERY {
          __typename
          id
          pageLayout: layout
          pages {
            cover {
              mime
              url
              localFile {
                thumbnail: childImageSharp {
                  gatsbyImageData(
                    width: 350
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                    transformOptions: { cropFocus: CENTER, fit: COVER }
                  )
                }
                full: childImageSharp {
                  gatsbyImageData(
                    width: 1000
                    placeholder: NONE
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }
            path
            locale
            title
            updatedAt
            description
            id
          }
          id
          productLayouts: layout
          products {
            name
            path
            catchphrase
            locale
            updatedAt
            catchphrases {
              data {
                catchphrases
              }
            }
            photos {
              mime
              url
              localFile {
                thumbnail: childImageSharp {
                  gatsbyImageData(
                    width: 350
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                    transformOptions: { cropFocus: CENTER, fit: COVER }
                  )
                }
                full: childImageSharp {
                  gatsbyImageData(
                    width: 1000
                    placeholder: NONE
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_UI_PHOTO_GALLERY {
          __typename
          id
          photos {
            ext
            alternativeText
            url
            mime
            localFile {
              thumbnail: childImageSharp {
                gatsbyImageData(
                  width: 350
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  transformOptions: { cropFocus: CENTER, fit: COVER }
                )
              }
              full: childImageSharp {
                gatsbyImageData(
                  width: 1000
                  placeholder: NONE
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_UI_SPACER {
          __typename
          id
          size
        }
        ... on STRAPI__COMPONENT_UI_STEPS {
          __typename
          id
          Block {
            Number
            title
            description {
              children {
                text
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_UI_TEXT {
          __typename
          id
          lessWide
          text {
            data {
              text
            }
          }
        }
        ... on STRAPI__COMPONENT_UI_TEXT_PHOTO {
          __typename
          id
          textPhotoText: text {
            text {
              data {
                text
              }
            }
          }
          title {
            content
            level
            secondary
          }
          images {
            ext
            alternativeText
            url
            mime
            localFile {
              thumbnail: childImageSharp {
                gatsbyImageData(
                  width: 750
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  transformOptions: { cropFocus: CENTER, fit: COVER }
                )
              }
              full: childImageSharp {
                gatsbyImageData(
                  width: 1000
                  placeholder: NONE
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          buttons {
            id
            label
            url
            variant
            align
          }
          layout
          Background
        }
        ... on STRAPI__COMPONENT_UI_TITLE {
          __typename
          id
          content
          secondary
          level
          lessWide
        }
      }
    }
  }
`
export default Page
